<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <div class="mt-4 text-center">
      <BaseCard heading="Nueva Asignación de Comedor">
        <v-card-text>
          <v-row>
            <v-col lg="6" md="6" sm="6" class="col-12">
              <v-text-field :value="trabajador" label="Trabajador" regular readonly></v-text-field>
            </v-col>
            <v-col lg="3" md="3" sm="3" class="col-8">
              <v-text-field :value="planilla" label="Planilla" regular readonly></v-text-field>
            </v-col>
            <v-col lg="2" md="2" sm="2" class="col-4">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" fab dark color="primary" @click="openDialog()">
                    <v-icon small dark>fas fa-search</v-icon>
                  </v-btn>
                </template>
                <span>Buscar Trabajador</span>
              </v-tooltip>
            </v-col>
            <EmpleadoBusqueda
              :selected="true"
              :dialog="dialog"
              @seleccionEmpleado="seleccionEmpleado($event)"
              @cancelar="cancelarDialogo()"
            ></EmpleadoBusqueda>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <h2>Turnos</h2>
              <v-chip-group column multiple v-model="seleccionTurnos">
                <v-chip
                  color="primary"
                  class="ma-2"
                  v-for="turno in turnos"
                  :key="turno"
                  filter
                  filter-icon="mdi-star"
                  draggable
                >
                  {{ turno }}
                </v-chip>
              </v-chip-group>
            </v-col>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <h2>Días</h2>
              <v-chip-group column multiple v-model="seleccionDias">
                <v-chip
                  class="ma-2"
                  v-for="dia in dias"
                  :key="dia"
                  filter
                  filter-icon="mdi-checkbox-marked-circle"
                  draggable
                >
                  {{ dia }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="cancelar()">Cerrar</v-btn>
          <v-btn color="info" submit @click="guardar()">Guardar</v-btn>
        </v-card-actions>
      </BaseCard>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'AsignacionFormulario',
  components: {
    EmpleadoBusqueda: () => import('./EmpleadoBusqueda')
  },
  data: () => ({
    desayuno: false,
    almuerzo: false,
    cena: false,
    seleccionDias: [0, 1, 2, 3, 4, 5, 6],
    seleccionTurnos: [0, 1, 2],
    asignacionService: null,
    dialog: false,
    trabajador: '',
    planilla: '',
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Asignación de Empleados',
        disabled: true
      },
      {
        text: 'Lista de Empleados Asignados',
        disabled: true
      },
      {
        text: 'Asignar',
        disabled: true
      }
    ],
    formValid: true,
    dias: ['LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB', 'DOM'],
    turnos: ['DESAYUNO', 'ALMUERZO', 'CENA']
  }),
  watch: {},
  methods: {
    openDialog() {
      this.dialog = true;
    },
    cancelarDialogo() {
      this.dialog = false;
    },
    async seleccionEmpleado(val) {
      this.desayuno = true;
      this.almuerzo = val[0].almuerzo;
      this.cena = true;
      this.trabajador = val[0].nombresall;
      this.planilla = val[0].planillafipe;
      this.cancelarDialogo();
    },
    cancelar() {
      this.$router.push({ path: '/comedor/asignacion' });
    },
    guardar() {
      this.$refs.form.validate();
    }
  },
  async mounted() {}
};
</script>
